import { Box, withStyles } from '@material-ui/core';

export const WrapperBox = withStyles(() => ({
  root: {},
}))(Box);

export const ContainerBox = withStyles(() => ({
  root: {
    width: '100%',
  },
}))(Box);
